import { Formik } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from 'react-bootstrap';

import CMSService from 'App/services/CMSService';
import { queryClient } from 'Shared/queryClient';
import toast from 'Shared/toast';
import contentGroupPropType from '../../types/contentGroupPropType';
import CreateAssociationFormArea from './CreateAssociationFormArea';

const CreateAssocationModal = ({ contentGroup, onClose }) => {
    return (
        <Modal show onHide={onClose}>
            <Modal.Header>
                <Modal.Title role="heading">Create Association</Modal.Title>
            </Modal.Header>
            <Formik
                initialValues={{}}
                onSubmit={async (values) => {
                    await CMSService.createChildContentGroup(contentGroup.uuid, values.resourceUuid.uuid);
                    toast.success('The resource has been associated successfully.');
                    queryClient.resetQueries(['contentGroup', contentGroup.uuid]);
                    onClose();
                }}
            >
                <CreateAssociationFormArea onClose={onClose} />
            </Formik>
        </Modal>
    );
};

CreateAssocationModal.propTypes = {
    contentGroup: contentGroupPropType.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default CreateAssocationModal;
